import React from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles((theme) => ({
  popupHeading: {
    fontFamily: 'Lato',
    fontSize: '20px',
    fontWeight: 600,
    lineHeight: '24px',
    marginBottom: '10px',
    marginTop: '0px',
  },
  popupCloseBtn: {
    borderRadius: '50%',
    backgroundColor: theme.palette.secondary.main,
    padding: '8px',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
    },
    cursor: 'pointer',
  },
  mainContainer: {
    position: 'sticky',
    top: 0,
    zIndex: 10,
    padding: '5px 20px',
    background: 'rgba(255, 255, 255, 1)',
    width: '100%',
    borderBottom: '1px solid #E4E7EC',
  },
}));

const PopupTopBar = ({ add, title, close }) => {
  const classes = useStyles();

  let heading;

  if (add === true) {
    heading = `Add ${title}`;
  } else if (add === false) {
    heading = `Edit ${title}`;
  } else {
    heading = title;
  }

  return (
    <Grid container direction="row" alignItems="center" className={classes.mainContainer}>
      <Grid item xs>
        <Grid container direction="column" justifyContent="flex-start" alignItems="flex-start">
          <Grid item className={classes.popupHeading}>
            {heading}
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <CloseIcon className={classes.popupCloseBtn} onClick={close} />
      </Grid>
    </Grid>
  );
};

export default PopupTopBar;
